import { TileArcGISRest } from "ol/source";

function tileArcGISRest({ url, selectedLayers = [] }) {
  // If first index is 0 that means that all layers should be shown so we can set show to 0
  const layers = `show:${
    selectedLayers[0] === 0 ? "0" : selectedLayers.join(",")
  }`;

  return new TileArcGISRest({
    url: url,
    crossOrigin: "Anonymous",
    params: {
      layers,
    },
  });
}

export default tileArcGISRest;
